import { render, staticRenderFns } from "./favorites-slider.vue?vue&type=template&id=9eba47f6&"
import script from "./favorites-slider.vue?vue&type=script&lang=js&"
export * from "./favorites-slider.vue?vue&type=script&lang=js&"
import style0 from "./favorites-slider.vue?vue&type=style&index=0&id=9eba47f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports